import { Observable } from 'rxjs'
import { VerifiedStateEnum } from '../shared.models'
import { Action } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

export interface SharedProfile {
  uuid?: string
  email?: string
  first_name?: string | null
  last_name?: string | null
  phone_number?: string | null
  invite_email?: string | null
  invite_phone_number?: string | null
  email_verified_state?: VerifiedStateEnum
  paddle_number?: number | null
  preferred_contact?: PreferredContactEnum | string
  user?: string | null | ProfileUserEntity
  has_payment_method?: boolean
}

export interface ProfileUserEntity {
  email: string | null
  email_verified_state: string
  first_name: string
  last_name: string
  phone_number: string | null
  phone_number_verified_state: VerifiedStateEnum
  uuid: string
}

export interface SharedProfileFacade extends GbBaseFacade {
  selectedProfile$: Observable<SharedProfile | undefined>
}

export interface AllProfilesFacade extends GbBaseFacade {
  allProfiles$: Observable<SharedProfile[]>
  loaded$: Observable<boolean>
}

export enum PreferredContactEnum {
  Email = 'email',
  Phone = 'phone_number',
}
